import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Stack,
} from '@mui/material';

const PromoGeneration = () => {
  const [promotionName, setPromotionName] = useState('');
  const [prefix, setPrefix] = useState('');
  const [series, setSeries] = useState('');
  const [sequence, setSequence] = useState('');
  const [seriesFrom, setSeriesFrom] = useState('');
  const [seriesTo, setSeriesTo] = useState('');
  const [promoCodes, setPromoCodes] = useState<string[]>([]);

  const handleGenerate = () => {
    const from = parseInt(seriesFrom, 10);
    const to = parseInt(seriesTo, 10);

    if (isNaN(from) || isNaN(to) || from > to) {
      alert('Please enter valid "Series From" and "Series To" values.');
      return;
    }

    const codes = [];
    for (let i = from; i <= to; i++) {
      codes.push(`${promotionName}${prefix}${series}${sequence}${i}`);
    }
    setPromoCodes(codes);
  };

  return (
    <>
      <Box className="headingBtnWrap">
        <Typography variant="h1">Promo Code Generation</Typography>
      </Box>
      <Box className="feeInputFieldWrap horizontalWrap promoWrap">
        <div className="form-control inputFieldWrap">
            <label>Promotion Name</label>
            <input type="text" className="inputField" value={promotionName} onChange={(e) => setPromotionName(e.target.value)} />
        </div>
        <div className="form-control inputFieldWrap">
            <label>Prefix</label>
            <input type="text" className="inputField" value={prefix} onChange={(e) => setPrefix(e.target.value)} />
        </div>
        <div className="form-control inputFieldWrap">
            <label>Series</label>
            <input type="text" className="inputField" value={series} onChange={(e) => setSeries(e.target.value)} />
        </div>
        <div className="form-control inputFieldWrap">
            <label>Sequence</label>
            <input type="text" className="inputField" value={sequence} onChange={(e) => setSequence(e.target.value)} />
        </div>
      </Box>
      <Box className="feeInputFieldWrap horizontalWrap promoWrap">
        <div className="form-control inputFieldWrap">
            <label>Series From</label>
            <input type="text" className="inputField" value={seriesFrom} onChange={(e) => setSeriesFrom(e.target.value)} />
        </div>
        <div className="form-control inputFieldWrap">
            <label>Series To</label>
            <input type="text" className="inputField" value={seriesTo} onChange={(e) => setSeriesTo(e.target.value)} />
        </div>
      </Box>

      {/* Generate Button */}
      <Box sx={{ mb: 3, mt: 3 }} className="searchInputFilterBox">
        <Button variant="contained" onClick={handleGenerate} className="searchBtn">
          Generate
        </Button>
      </Box>

      {/* Promo Code List */}
      <Box>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Promo Code
        </Typography>
        <Stack spacing={1}>
          {promoCodes.map((code, index) => (
            <Typography key={index}>{code}</Typography>
          ))}
        </Stack>
      </Box>
      
    </>
  );
};

export default PromoGeneration;

